module.exports = __webpack_public_path__ + "img/cgfk.1fb7a8db.png";